import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import "@restspace/schema-form/build/index.css"
import './App.scss';
import './restspace.scss';
import { SchemaEditor } from './components/schema-editor';
import { SchemaSubmitForm } from '@restspace/schema-form';
import Ajv from "ajv";
import { exampleSchemas } from './example-schemas';
import _ from "lodash";

const fadeTime = 250;

function App() {
  const initSchema = { type: "object", properties: { } } as object;
  const [ schemaInput, setSchemaInput ] = useState(_.clone(initSchema));
  const [ schema, setSchema ] = useState(_.clone(initSchema));
  const [ value, setValue ] = useState({});
  const [ delayedNewSchema, setDelayedNewSchema ] = useState<object | null>(null);
  const [ formAnimateClass, setFormAnimateClass ] = useState('');

  const onDoSubmit = (val: object) => {
    setValue(val);
    return Promise.resolve(true);
  }

  useEffect(() => {
    if (delayedNewSchema != null) {
      setFormAnimateClass('fade-out');
      setTimeout(() => {
        setSchema(_.clone(delayedNewSchema));
        setDelayedNewSchema(null);
        setFormAnimateClass('fade-in');
      }, fadeTime);
    }
  }, [ delayedNewSchema ]);

  const updateSchema = (newSchema: object) => {
    setSchemaInput(newSchema);
    if (!(newSchema.hasOwnProperty('properties') && newSchema.hasOwnProperty('type'))) return;
    const ajv = new Ajv({ allErrors: true });
    if (!ajv.validateSchema(newSchema)) return;
    setDelayedNewSchema(newSchema);
    setValue({});
  }

  const onSchemaInputChange = (newSchema: object) => {
    updateSchema(newSchema);
  }

  const onExampleSchemaChange = (ev: React.ChangeEvent<HTMLSelectElement>) => {
    const idx = ev.target.value;
    let newSchema: object;
    if (exampleSchemas.hasOwnProperty(idx)) {
      newSchema = exampleSchemas[idx];
    } else if (!idx) {
      newSchema = initSchema;
    } else return;
    updateSchema(_.clone(newSchema));
  }

  console.log('rerender');
  return (
    <div className="App">
      <div className="editor-container">
        <h2>Schema</h2>
        <div className="selector">
          <label htmlFor='schema-select'>Load example schema</label>
          <select id='schema-select' onChange={onExampleSchemaChange}>
            <option value=''>Empty</option>
            <option value='basic'>Basic</option>
            <option value='selector'>Selector</option>
            <option value='login'>Login</option>
            <option value='oneOf'>OneOf</option>
            <option value='recursive'>Recursive</option>
          </select>
        </div>
        <div className="box editor-box">
          <SchemaEditor
            schema={schemaInput}
            onValue={onSchemaInputChange}/>
        </div>
      </div>
      <div className="form-container">
        <h2>Form</h2>
        <div className="box form-box restspace-theme">
            <SchemaSubmitForm {...{ schema, value }}
                className={formAnimateClass}
                onSubmit={onDoSubmit}
                makeSubmitLink={(onClick) => (
                  <div className='sf-submit-button' onClick={onClick}>Submit</div>
              )}
                collapsible={true}
            />
        </div>
      </div>
      <div className="output-container">
        <h2>Output</h2>
        <div className="box output-box">
          <pre>
            {JSON.stringify(value, null, 4)}
          </pre>
        </div>
      </div>
    </div>
  );
}

export default App;
